module.exports = "<div class=\"ui-card padding-md\">\r\n  <div class=\"margin-md\">\r\n    <div class=\"ui-title-2\">{{::$ctrl.empresa.Nombre | capitalize}}</div>\r\n    <small>ID {{::$ctrl.empresa.ID_Empresa}}</small>\r\n  </div>\r\n</div>\r\n<nominas-informacionfiscal-empresas-empresa-config\r\n    ng-if=\"!$ctrl.data\"></nominas-informacionfiscal-empresas-empresa-config>\r\n<nominas-informacionfiscal-empresas-empresa-descarga\r\n    ng-if=\"$ctrl.data\"></nominas-informacionfiscal-empresas-empresa-descarga>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/informacionfiscal/components/empresas/empresa/template.html
// module id = 1046
// module chunks = 0